import { MARKETPLACE_FETCHER_ACTIONS } from "../../actions/marketplaceActions";
import { cloneObject } from "../../helpers/helper";

const defaultState = {
  data : null,
  failed : false
}

const marketplaceDataReducer = (state = cloneObject(defaultState), action) => {  
    switch (action.type) {
      case MARKETPLACE_FETCHER_ACTIONS.FETCH_DATA_SUCCESS: {
        state = {
          ...state,
          data: action.payload.data
        };
        break;
      }
      case MARKETPLACE_FETCHER_ACTIONS.FETCH_DATA_SUCCESS: {
        state = {
          ...state,
          failed: true
        };
        break;
      }
    }    
  return state;
}

  export default marketplaceDataReducer;
